{
  "title": "Byråimport",
  "toolbar": {
    "save": "Lagre visningsinnstillinger",
    "saveRequiresFilter": "Alle kolonner må ha minst ett filter",
    "addColumn": "Legg til kolonne",
    "markSaved": "Merk som lagret",
    "markSavedDisabled": "Velg byråmeldinger for å merke som lagret",
    "markRead": "Merk som lest",
    "markReadDisabled": "Velg byråmeldinger for å merke som lest",
    "markUsed": "Merk som brukt",
    "markUsedDisabled": "Velg byråmeldinger for å merke som brukt",
    "createArticle": "Opprett artikkel med tilhørende plan fra byråmelding",
    "createArticleDisabled": "Velg byråmeldinger for å opprette artikkel med tilhørende plan",
    "createArticleAriaLabel": "Opprett artikkel fra byråmelding"
  },
  "stream": {
    "addFilter": "Legg til filter for å vise byråmeldinger",
    "loadingMore": "Laster flere...",
    "noTitle": "Ingen tittel",
    "deselectHint": "for å fjerne merking av valgte byråmeldinger"
  },
  "banner": {
    "offline": "Du er frakoblet — byråmeldinger gjenopptas ved tilkobling",
    "streamErrors": "{{count}} strøm kunne ikke oppdateres",
    "streamErrors_other": "{{count}} strømmer kunne ikke oppdateres"
  },
  "filter": {
    "freeText": "Fritekst",
    "searchOptions": "Søk alternativ",
    "section": "Kategori",
    "sources": "Kilder",
    "newsvalue": "Nyhetsverdi",
    "wireStatus": "Meldingsstatus",
    "selected": "valgte"
  },
  "toast": {
    "openPlanning": "Åpne plan",
    "openArticle": "Åpne artikkel",
    "statusChangeFailed": "En eller flere statusendringer mislyktes!"
  },
  "settings": {
    "saveError": "Kunne ikke lagre innstillinger",
    "unknownError": "En ukjent feil oppstod"
  },
  "creation": {
    "title": "Opprett artikkel",
    "selectPlanning": "Velg plan",
    "showOlder": "Vis eldre",
    "planningTitle": "Plantittel",
    "articleTitle": "Tittel",
    "assignmentTitle": "Oppdragstittel",
    "noPlanningHint": "Hvis du ikke velger en plan, vil en ny plan med tilhørende oppdrag bli opprettet for deg.",
    "withPlanningHint": "Denne artikkelen vil bli lagt i et nytt oppdrag i den valgte planen",
    "dialogTitle": "Opprett artikkel fra byråmelding",
    "dialogNoPlanningDescription": "En ny plan med tilhørende oppdrag for denne artikkelen vil bli opprettet for deg.",
    "dialogWithPlanningDescription": "Denne artikkelen vil bli lagt i et nytt oppdrag i planen \"{{planningLabel}}\"",
    "articleCreated": "Artikkel opprettet",
    "createError": "Kunne ikke opprette en artikkel!",
    "createError2": "Kunne ikke opprette ny artikkel!",
    "planningMissingSection": "Valgt plan mangler kategori og kan ikke brukes.",
    "assignmentRollbackError": "Artikkelen kunne ikke bekreftes som lagret, og oppgaven kunne ikke slettes. Vennligst sjekk planen manuelt.",
    "markUsed": "Merk som brukt",
    "createButton": "Opprett artikkel",
    "embargo": "Embargo til",
    "translateToNynorsk": "Oversettelse",
    "translationNone": "Ingen",
    "translationStandard": "Standard",
    "translationPersonal": "Personlige preferanser",
    "translationError": "Oversettelse mislyktes. Artikkelen ble opprettet uten oversettelse."
  },
  "sources": {
    "title": "Kilder",
    "errorTitle": "Artikeldokument mangler",
    "errorMessage": "Ingen artikeldokument er angitt. Naviger tilbake til oversikten og prøv igjen.",
    "noWires": "Ingen kildebyråmeldinger",
    "loadingWire": "Laster byråmelding…",
    "sourceWires": "Kildemelding"
  },
  "preview": {
    "pressRelease": "Pressemelding",
    "statusRead": "Lest",
    "statusSaved": "Lagret",
    "statusUsed": "Brukt",
    "version": "Versjon"
  },
  "history": {
    "status": {
      "done": "Klar",
      "saved": "Lagret",
      "approved": "Godkjent",
      "read": "Lest",
      "usable": "Publisert",
      "used": "Brukt",
      "withheld": "Tidspublisert",
      "cancelled": "Avbrutt",
      "unpublished": "Avpublisert",
      "flash": "Flash",
      "system": "System"
    }
  }
}
